import moment from "moment";
import React, { useState } from "react";
import ZithasLogo from "../../../assets/images/main-zithas.png"
import { Link } from "react-router-dom";
import configure from "configure";
import { useSelector } from "react-redux";
import { checkPermissionsByModule } from "utils/common-helpers";
import { Dropdown, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";

export const LeaveManagementColumns = (onLeaveDetail) => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div className="text-center">{cellProps?.row?.original?.id}</div>
            )
        }
    },
    {
        Header: "Applied On",
        accessor: "applied_on",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lapplied_on_box",
        Cell: cellProps => {
            return (
                <div>{moment(cellProps?.row?.original?.created_at).format('DD-MM-YYYY')}</div>
            )
        }
    },
    {
        Header: "Employee Name",
        accessor: "name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_name_box",
    },
    {
        Header: "Employee Code",
        accessor: "emp_id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lemployee_code-box text-center",
    },
    {
        Header: "Punch ID",
        accessor: "punch_id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lpunch_id_box text-center",
    },
    {
        Header: "Reason",
        accessor: "leave_reason",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lreason_box",
    },
    {
        Header: "Action",
        accessor: "action",
        className: "text-center laction",
        Cell: cellProps => {
            const role = useSelector((state) => state?.Roles?.apiData)
            const permission = checkPermissionsByModule(role, 40, 5)
            return (
                <div className="text-center">
                    {permission ? (
                        <a
                            title="Leave Details"
                            className="btn btn-sm btn-outline-secondary me-1"
                            onClick={() => onLeaveDetail(cellProps?.row?.original?.id, cellProps?.row?.original?.employee, cellProps?.row?.original, 1)}
                        >
                            <i className="bi bi-info-lg"></i>
                        </a>
                    ) : null}
                    <a
                        title="View Details"
                        className="btn btn-sm btn-outline-secondary me-1"
                        onClick={() => onLeaveDetail(cellProps?.row?.original?.id, cellProps?.row?.original?.employee, cellProps?.row?.original, 0)}
                    >
                        <i className="bi bi-eye"></i>
                    </a>

                </div>
            )
        },
    },
]

export const punchDetailsColumns = () => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
    },
    {
        Header: "Employee",
        accessor: "emply",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center ",
        Cell: cellProps => {
            return (
                <div className="d-flex gap-2 align-items-center">
                    <img src={ZithasLogo} alt="No img" width={25} height={25} className="object-fit-cover rounded-circle" />
                    <span>Zainul Abedin Marchawala - 1991 </span>
                </div>
            )
        }

    },
    {
        Header: "Approved Leaves",
        accessor: "approve",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>0</div>
            )
        }
    },
    {
        Header: "UnApproved Leaves",
        accessor: "unapprove",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>0</div>
            )
        }
    },
    {
        Header: "Total Leaves",
        accessor: "total_leaves",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>0</div>
            )
        }
    },
    {
        Header: "Late Punch",
        accessor: "punch",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>0</div>
            )
        }
    },
    {
        Header: "No. working Days",
        accessor: "working_days",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>25</div>
            )
        }
    },
    {
        Header: "Productivity Hours",
        accessor: "hrs",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center lemp-id",
        Cell: cellProps => {
            return (
                <div>250/500</div>
            )
        }
    },
]

export const salarySlipColumns = () => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center salary-slip-id",
    },

    {
        Header: "Employee Code",
        accessor: "employee_code",
        isInfoIcon: false,
        isShortIcon: true,
        className: "salary-slip-empcode",
        Cell: cellProps => {
            return (
                <div>{cellProps?.row?.original?.employee_code || '-'}</div>
            )
        }
    },

    {
        Header: "Employee Name",
        accessor: "name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "salary-slip-empname",
        Cell: cellProps => {
            return (
                <div>{cellProps?.row?.original?.name || '-'}</div>
            )
        }
    },
    {
        Header: "Department",
        accessor: "department_name",
        isInfoIcon: false,
        isShortIcon: true,
        className: "salary-slip-department",
        Cell: cellProps => {
            return (
                <div>{cellProps?.row?.original?.department_name || '-'}</div>
            )
        }
    },
    {
        Header: "Designation",
        accessor: "designation",
        isInfoIcon: false,
        isShortIcon: true,
        className: "salary-slip-designation",
        Cell: cellProps => {
            return (
                <div>{cellProps?.row?.original?.designation || '-'}</div>
            )
        }
    },
    {
        Header: "Action",
        accessor: "action",
        className: "text-center salary-slip-action",
        Cell: cellProps => {
            return (
                <div>
                    <Link
                        to={`${configure.appUrl}generate-salary-slip/${cellProps?.row?.original?.id}`}
                        title="view"
                        className="btn btn-sm btn-outline-secondary me-1"
                    >
                        <i className="fas fa-eye "></i>
                    </Link>
                </div>
            )
        },
    },
]

export const salarySheetColumns = (statusChange, getLeaveDates) => [
    {
        Header: "",
        accessor: "select",
        title: "ID",
        isInfoIcon: false,
        isShortIcon: false,
        isSelect: true,
        className: "text-center s_select",
        Cell: cellProps => {
            return (
                <div className="text-center">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                        defaultChecked={cellProps.row.original.pending_status == "0"}
                        onChange={e =>
                            statusChange(
                                cellProps.row.original.id,
                            )
                        }
                    />
                </div>
            )
        },
    },
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "text-center salary-sr",
    },

    {
        Header: "Name",
        accessor: "name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "salary-name",
    },

    {
        Header: "Total Days",
        accessor: "days",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-days",
    },
    {
        Header: "ASL",
        accessor: "sick_leave",
        title: "Approved Sick Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-asl",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 1)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.sick_leave === "0" ? (
                        <div>{data?.sick_leave}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.sick_leave}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "USL",
        accessor: "dsl",
        title: "Unapproved Sick Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-usl",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 1)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.dsl === "0" ? (
                        <div>{data?.dsl}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.dsl}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "AEL",
        accessor: "approved_leave",
        title: "Approved Earned Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-ael",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 2)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.approved_leave === "0" ? (
                        <div>{data?.approved_leave}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.approved_leave}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "UEL",
        accessor: "unapproved_leave",
        title: "Unapproved Earned Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-uel",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 2)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.unapproved_leave === "0" ? (
                        <div>{data?.unapproved_leave}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.unapproved_leave}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "ACL",
        accessor: "emergency_leave",
        title: "Approved Casual Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-acl",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 3)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.emergency_leave === "0" ? (
                        <div>{data?.emergency_leave}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.emergency_leave}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "UCL",
        accessor: "dcl",
        title: "Unapproved Casual Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-ucl",
        Cell: cellProps => {
            const [isOpen, setIsOpen] = useState(false)
            const [leaveDates, setLeaveDates] = useState([])
            const data = cellProps?.row.original

            const handleToggle = async () => {
                if (!isOpen) {
                    const dates = await getLeaveDates(data?.user_id, data?.month, 3)
                    setLeaveDates(dates) // assuming API returns an array of dates
                    setIsOpen(true)
                } else {
                    setIsOpen(false)
                }
            }
            return (
                <>
                    {data?.dcl === "0" ? (
                        <div>{data?.dcl}</div>
                    ) : (
                        <Dropdown isOpen={isOpen} toggle={handleToggle} className="dropdown">
                            <DropdownToggle className="btn-none">
                                <div>{data?.dcl}</div>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <ul className="mb-0">
                                    {leaveDates.map((obj, i) => (
                                        <li key={i}> {moment(obj?.leave_dates).format('DD-MM-YYYY')} </li>
                                    ))}
                                </ul>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </>
            )
        }
    },
    {
        Header: "UIL",
        accessor: "uninformed_leave",
        title: "Uninformed Leave",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-uil",
    },
    {
        Header: "LP",
        accessor: "late_punch",
        title: "Late Punch",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-lp",
    },
    {
        Header: "Total Leaves",
        accessor: "total_leave",
        title: "Late Punch",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-total_leaves",
    },
    {
        Header: "Net Leaves",
        accessor: "net_leave",
        title: "Net Leaves",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-total_leaves",
    },
    {
        Header: "Worked Days",
        accessor: "gwd",
        title: "Worked Days",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-worked-days",
    },
    {
        Header: "Amount",
        accessor: "salary",
        title: "Amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center salary-amount",
        Cell: cellProps => {
            return (
                <div>
                    {Number(cellProps?.row?.original?.salary).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) || 0}
                </div>
            )
        }
    },
]

export const leaveBalanceColumns = () => [
  {
    Header: "Sr No",
    accessor: "id",
    className: "text-center",
    Cell: (cellProps) => cellProps.row.index + 1,
  },
  {
    Header: "Month - Year",
    accessor: "month",
    className: "text-center",
    Cell: (cellProps) => {
      const month = cellProps?.row?.original?.month;
      return (
        moment()
          .month(month - 1)
          .format("MMMM") +
        " - " +
        moment().format("YYYY")
      );
    },
  },
  {
    Header: "EL Credit",
    accessor: "credit.EL",
    className: "text-center bg-green",   // :large_green_circle: green
    Cell: (cellProps) => cellProps?.row?.original?.credit?.EL ?? 0,
  },
  {
    Header: "EL Used",
    accessor: "used.EL",
    className: "text-center targ-qty",   // :red_circle: red
    Cell: (cellProps) => cellProps?.row?.original?.used?.EL ?? 0,
  },
  {
    Header: "SL Credit",
    accessor: "credit.SL",
    className: "text-center bg-green",   // :large_green_circle: green
    Cell: (cellProps) => cellProps?.row?.original?.credit?.SL ?? 0,
  },
  {
    Header: "SL Used",
    accessor: "used.SL",
    className: "text-center targ-qty",   // :red_circle: red
    Cell: (cellProps) => cellProps?.row?.original?.used?.SL ?? 0,
  },
  {
    Header: "CL Credit",
    accessor: "credit.CL",
    className: "text-center bg-green",   // :large_green_circle: green
    Cell: (cellProps) => cellProps?.row?.original?.credit?.CL ?? 0,
  },
  {
    Header: "CL Used",
    accessor: "used.CL",
    className: "text-center targ-qty",   // :red_circle: red
    Cell: (cellProps) => cellProps?.row?.original?.used?.CL ?? 0,
  },
  {
    Header: "Balance Leave",
    accessor: "balance",
    className: "text-center balance-purple",   // :large_purple_circle: purple via CSS
    Cell: (cellProps) => {
      const balance = cellProps?.row?.original?.balance || {};
      return (
        <span>
          EL: {balance.EL ?? 0} &emsp;|&emsp; SL: {balance.SL ?? 0}{" "}
          &emsp;|&emsp; CL: {balance.CL ?? 0}
        </span>
      );
    },
  },
];